
import Vue from 'vue'
import mySubmitButton from  '@/components/submitButton/index'
import userInfoHead  from  '@/components/userInfoHead/index'
import dateRangeSearch  from  '@/components/dateRangeSearch/index'
import uploadImage from '@/components/uploadImage/index'
import datePicker from '@/components/datePicker/index'
import tabDate  from  '@/components/tabDate/index'
Vue.component('submit', mySubmitButton)
Vue.component('user-info-head', userInfoHead)
Vue.component('date-range-search', dateRangeSearch)
Vue.component('upload-image', uploadImage)
Vue.component('date-picker', datePicker)
Vue.component('tab-date', tabDate)

import XButton from 'vux/src/components/x-button/index.vue'
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Datetime from 'vux/src/components/datetime/index.vue'
import Selector from 'vux/src/components/selector/index.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import GroupTitle from 'vux/src/components/group-title/index.vue'
import ViewBox from 'vux/src/components/view-box/index.vue'
import Scroller from 'vux/src/components/scroller/index.vue'
import LoadMore from 'vux/src/components/load-more/index.vue'
import Search from 'vux/src/components/search/index.vue'
import Divider from 'vux/src/components/divider/index.vue'
import PopupRadio from 'vux/src/components/popup-radio/index.vue'
import Previewer from 'vux/src/components/previewer/index.vue'
import Rater from 'vux/src/components/rater/index.vue'
import Badge from 'vux/src/components/badge/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'
import Countup from 'vux/src/components/countup/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Icon from 'vux/src/components/icon/index.vue'
import CheckIcon from 'vux/src/components/check-icon/index.vue'
import Checklist from 'vux/src/components/checklist/index.vue'
import Qrcode from 'vux/src/components/qrcode/index.vue'
import CellFormPreview from 'vux/src/components/cell-form-preview/index.vue'
import FormPreview from 'vux/src/components/form-preview/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'


Vue.use(ConfirmPlugin)
Vue.component('x-button', XButton)
Vue.component('tabbar', Tabbar)
Vue.component('tabbar-item', TabbarItem)
Vue.component('group', Group)
Vue.component('cell', Cell)
Vue.component('x-input', XInput)
Vue.component('datetime', Datetime)
Vue.component('selector', Selector)
Vue.component('popup-picker', PopupPicker)
Vue.component('x-textarea', XTextarea)
Vue.component('group-title', GroupTitle)
Vue.component('view-box', ViewBox)
Vue.component('scroller', Scroller)
Vue.component('load-more', LoadMore)
Vue.component('search', Search)
Vue.component('divider', Divider)
Vue.component('popup-radio', PopupRadio)
Vue.component('previewer', Previewer)
Vue.component('rater', Rater)
Vue.component('badge', Badge)
Vue.component('x-dialog', XDialog)
Vue.component('tab', Tab)
Vue.component('tab-item', TabItem)
Vue.component('swiper', Swiper)
Vue.component('swiper-item', SwiperItem)
Vue.component('countup', Countup)
Vue.component('flexbox', Flexbox)
Vue.component('flexbox-item', FlexboxItem)
Vue.component('icon', Icon)
Vue.component('check-icon',CheckIcon)
Vue.component('checklist',Checklist)
Vue.component('qrcode',Qrcode)
Vue.component('cell-form-preview',CellFormPreview)
Vue.component('form-preview',FormPreview)
Vue.component('confirm',Confirm)




// WEBPACK FOOTER //
// ./src/assets/js/utils/component.js